import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import ChatAssistant from './ChatAssistant';
import './Layout.css';

const Layout = ({ children }) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <Sidebar />
      <div className="layout-main">
        <header className="layout-header">
          <div className="header-content">
            <div className="header-left">
              <img src="/chulas.png" alt="Chula's Logo" className="header-logo" />
              <h1>Admin Portal</h1>
            </div>
            <div className="header-actions">
              <span className="current-user">
                {user?.signInDetails?.loginId || 'Admin'}
              </span>
              <button onClick={handleLogout} className="logout-button">
                Sign Out
              </button>
            </div>
          </div>
        </header>
        <main className="layout-content">
          {children}
        </main>
      </div>
      <ChatAssistant />
    </div>
  );
};

export default Layout;
